import Vue from 'vue'
import PictureInput from 'vue-picture-input'

Vue.component('picture-input', PictureInput)
